<template>
    <div class="halfwidth-yellow1 wider mbar mbar12" style="background-color: #1daeef;pointer-events:none;">
                 <div class="coming-soon2" style="color: #fff;">coming soon</div>
<svg xmlns="http://www.w3.org/2000/svg" style="opacity:1" viewBox="0 0 375.3 110.7"><g id="Layer_2" data-name="Layer 2"><g id="Layer_1-2" data-name="Layer 1"><path class="cls-1mbargrey" d="M174.6,48.4a24.41,24.41,0,0,0-22.4,14.7V.1h-2V72.9a24.4,24.4,0,1,0,24.4-24.5Zm0,46.9a22.43,22.43,0,0,1-22.4-22.4v-.3a22.4,22.4,0,1,1,22.4,22.7Z"/><path class="cls-1mbargrey" d="M285.5,110.5h-2v-7.4c.7-.5,1.4-1.1,2-1.6Z"/><path class="cls-1mbargrey" d="M351.6,48.5a19.82,19.82,0,0,0-19.8,19.7v42.3h2V68.2a17.8,17.8,0,0,1,17.7-17.7,17.43,17.43,0,0,1,13.4,6.2l1.4-1.5A19.26,19.26,0,0,0,351.6,48.5Z"/><path class="cls-1mbargrey" d="M86.7,48.4A19.89,19.89,0,0,0,68.2,61.2a31.68,31.68,0,0,1,.7,6.9h0a17.7,17.7,0,0,1,35.4.1v42.4h2V68.2A19.61,19.61,0,0,0,86.7,48.4Z"/><path class="cls-1mbargrey" d="M174.6,39.6a33.14,33.14,0,0,0-22.4,8.7v2.9a31.19,31.19,0,1,1-8.8,21.7V.1h-2V72.9a33.2,33.2,0,1,0,33.2-33.3Z"/><path class="cls-1mbargrey" d="M145.8,110.5h2V99.3c-.7-.7-1.4-1.5-2-2.2Z"/><path class="cls-1mbargrey" d="M294.3,110.5h-2V94a37.91,37.91,0,0,0,2-3.4Z"/><path class="cls-1mbargrey" d="M351.5,39.5a28.59,28.59,0,0,0-28.6,28.6v42.3h2V68.1a26.65,26.65,0,0,1,26.6-26.6A26.33,26.33,0,0,1,370.9,50l1.4-1.5A28.6,28.6,0,0,0,351.5,39.5Z"/><path class="cls-1mbargrey" d="M86.7,39.5A28.61,28.61,0,0,0,64,50.7a18.58,18.58,0,0,1,1.1,1.9,26.59,26.59,0,0,1,48.2,15.5v42.4h2V68.1A28.66,28.66,0,0,0,86.7,39.5Z"/><path class="cls-1mbargrey" d="M35.9,44A24.2,24.2,0,0,0,11.7,68.1v42.3h2V68.2a22.2,22.2,0,0,1,44.4,0v42.3h2V68.2A24.22,24.22,0,0,0,35.9,44Z"/><path class="cls-1mbargrey" d="M290,35.2h-2V72.9a26.82,26.82,0,1,1-4.4-14.7V54.8A28.8,28.8,0,1,0,290,72.9Z"/><path class="cls-1mbargrey" d="M141.4,110.5h2V94a37.91,37.91,0,0,1-2-3.4Z"/><path class="cls-1mbargrey" d="M174.6,35.2a37.84,37.84,0,0,0-22.4,7.4v2.6a35.13,35.13,0,0,1,22.4-7.9,35.6,35.6,0,1,1-35.6,36V.1h-2V73.3a39.59,39.59,0,0,0,2,11.9,38.7,38.7,0,0,0,13.3,18.1,37.68,37.68,0,1,0,22.3-68.1Z"/><path class="cls-1mbargrey" d="M298.8,110.5h-2V85.1a35.81,35.81,0,0,0,2-11.9Z"/><path class="cls-1mbargrey" d="M318.5,68.2v42.3h2V68.2a31.94,31.94,0,0,1,.8-7,7.84,7.84,0,0,1-1.8-1.1A35.92,35.92,0,0,0,318.5,68.2Z"/><path class="cls-1mbargrey" d="M351.6,35.2a32.7,32.7,0,0,0-22.3,8.7c-.5.5-1.1,1-1.6,1.6a6.92,6.92,0,0,1,1.9,1,19.2,19.2,0,0,1,1.5-1.4,30.72,30.72,0,0,1,20.5-7.8A30.34,30.34,0,0,1,373.9,47l1.4-1.5A32.66,32.66,0,0,0,351.6,35.2Z"/><path class="cls-1mbargrey" d="M86.7,35.2A33,33,0,0,0,61.3,47.1c.4.5.9,1.1,1.3,1.7a31,31,0,0,1,55.1,19.5v42.3h2V68.2A33,33,0,0,0,86.7,35.2Z"/><path class="cls-1mbargrey" d="M35.9,39.5A28.59,28.59,0,0,0,7.3,68.1v42.4h2V68.1a26.6,26.6,0,0,1,53.2,0v42.4h2V68.1A28.59,28.59,0,0,0,35.9,39.5Z"/><path class="cls-1mbargrey" d="M9.5,43.1A9.56,9.56,0,0,0,0,52.6a9.29,9.29,0,0,0,3.9,7.6H4a10.42,10.42,0,0,0,1.8,1h0c.2-.7.3-1.3.5-2h0a9.91,9.91,0,0,1-1.7-1.1H4.5A7.49,7.49,0,0,1,2,52.6a7.38,7.38,0,0,1,7.4-7.4,8.6,8.6,0,0,1,2.4.4c.5-.5,1-1.1,1.6-1.6A8.3,8.3,0,0,0,9.5,43.1Z"/><path class="cls-1mbargrey" d="M294.4,35.2h-2V72.9a31.23,31.23,0,1,1-8.8-21.7V48.3a33.2,33.2,0,1,0,10.8,24.5Z"/><path class="cls-1mbargrey" d="M136.9,110.5h2V85.1a35.81,35.81,0,0,1-2-11.9Z"/><path class="cls-1mbargrey" d="M325.2,43a9.5,9.5,0,0,0-5.7,17.1,17.39,17.39,0,0,0,1.8,1.1c.2-.7.3-1.3.5-2A9.39,9.39,0,0,1,320,58a7.36,7.36,0,0,1,5-12.8,6.37,6.37,0,0,1,2.4.4c.5-.5,1-1.1,1.6-1.6A7.66,7.66,0,0,0,325.2,43Z"/><path class="cls-1mbargrey" d="M4,60.3H4a29.51,29.51,0,0,0-1,7.9v42.3H5v-44c.1-1.2.2-2.4.4-3.6.1-.6.2-1.1.3-1.6h0a9.5,9.5,0,0,1-1.7-1C3.9,60.3,4.5,60.7,4,60.3Z"/><path class="cls-1mbargrey" d="M35.9,35.2A33.29,33.29,0,0,0,13.4,44c-.5.5-1.1,1-1.6,1.6h0a5.24,5.24,0,0,1,1.8,1l1.5-1.4A31,31,0,0,1,66.8,68.3v42.3h2V68.2A32.88,32.88,0,0,0,35.9,35.2Z"/><path class="cls-1mbargrey" d="M298.8,35.2h-2V73.3a35.55,35.55,0,1,1-13.2-28.1V42.6a37.6,37.6,0,1,0-22.4,67.8,36.66,36.66,0,0,0,22.3-7.4,37.09,37.09,0,0,0,10.8-12.5,38.17,38.17,0,0,0,2.4-5.5,35.81,35.81,0,0,0,2-11.9Z"/><path class="cls-1mbargrey" d="M174.6,44a28.93,28.93,0,0,0-22.4,10.7v3.4a26.79,26.79,0,1,1-4.4,14.7V0h-2V72.8A28.8,28.8,0,1,0,174.6,44Z"/><path class="cls-1mbargrey" d="M150.2,110.5h2v-7.4c-.7-.5-1.4-1.1-2-1.6Z"/><path class="cls-1mbargrey" d="M289.9,110.5h-2V99.3c.7-.7,1.4-1.5,2-2.2Z"/><path class="cls-1mbargrey" d="M351.6,44a24.2,24.2,0,0,0-24.2,24.1v42.3h2V68.1A22.19,22.19,0,0,1,351.6,46,21.9,21.9,0,0,1,368,53.3l1.4-1.5A24.71,24.71,0,0,0,351.6,44Z"/><path class="cls-1mbargrey" d="M86.7,44A24.34,24.34,0,0,0,66.3,55.2l.9,2.4a22.13,22.13,0,0,1,41.6,10.5v42.3h2V68.2A24.2,24.2,0,0,0,86.7,44Z"/><path class="cls-1mbargrey" d="M35.9,48.4A19.82,19.82,0,0,0,16.2,68.2v42.4h2V68.2a17.7,17.7,0,0,1,35.4,0v42.4h2V68.2A19.7,19.7,0,0,0,35.9,48.4Z"/><path class="cls-1mbargrey" d="M285.6,35.2h-2V63.1a24.42,24.42,0,1,0,2,9.7Zm-24.4,60a22.4,22.4,0,1,1,22.4-22.7h0v.2A22.45,22.45,0,0,1,261.2,95.2Z"/></g></g></svg>
    <!-- <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 93.89 27.14">
      <defs />
      <g id="Layer_2" data-name="Layer 2">
        <g id="Layer_1-2" data-name="Layer 1">
          <path class="cls-178" d="M71.45,27.14V24.93l-.51.4v1.81Z" />
          <path
            class="cls-178"
            d="M83,16.73v10.4h.51V16.73A4.41,4.41,0,0,1,88,12.39a4.46,4.46,0,0,1,3.35,1.51l.35-.37A5,5,0,0,0,88,11.89,4.91,4.91,0,0,0,83,16.73Z"
          />
          <path class="cls-178" d="M36.48,27.14H37V24.39a6.64,6.64,0,0,1-.51-.55Z" />
          <path class="cls-178" d="M73.14,27.14h.51V22.25a8.05,8.05,0,0,1-.51.83Z" />
          <path
            class="cls-178"
            d="M80.81,16.72V27.13h.51V16.72A6.59,6.59,0,0,1,88,10.2a6.7,6.7,0,0,1,4.86,2.08l.34-.37A7.18,7.18,0,0,0,88,9.69,7.11,7.11,0,0,0,80.81,16.72Z"
          />
          <path
            class="cls-178"
            d="M21.69,9.69A7.22,7.22,0,0,0,16,12.45c.09.16.19.31.28.48a6.66,6.66,0,0,1,12.05,3.79V27.14h.51V16.72A7.11,7.11,0,0,0,21.69,9.69Z"
          />
          <path
            class="cls-178"
            d="M9,10.8a6,6,0,0,0-6.06,5.93V27.14h.51V16.73a5.54,5.54,0,0,1,11.08,0V27.14H15V16.73A6,6,0,0,0,9,10.8Z"
          />
          <path class="cls-178" d="M35.38,27.14h.51V23.08a7.11,7.11,0,0,1-.51-.83Z" />
          <path
            class="cls-178"
            d="M43.68,8.64a9.48,9.48,0,0,0-5.6,1.81V0h-.51V17.89a6,6,0,1,0,.51-2.4V14.28a6.73,6.73,0,0,1,5.6-3A6.59,6.59,0,1,1,37,17.89V0h-.51s0,17.86,0,17.89a7.22,7.22,0,1,0,7.22-7.09,7.25,7.25,0,0,0-5.6,2.63v-.88a7.87,7.87,0,0,1,5.6-2.33,7.67,7.67,0,1,1-7.81,7.67V0h-.51V17.89a8.32,8.32,0,1,0,8.32-8.17,8.38,8.38,0,0,0-5.6,2.13v-.76a9,9,0,0,1,5.6-1.95,8.84,8.84,0,0,1,8.91,8.75A8.91,8.91,0,0,1,34.77,18V0h-.51V27.14h.51V20.89a9.44,9.44,0,0,0,18.33-3A9.35,9.35,0,0,0,43.68,8.64Zm0,3.75a5.5,5.5,0,1,1-5.6,5.5v-.07A5.55,5.55,0,0,1,43.68,12.39Z"
          />
          <path
            class="cls-178"
            d="M88,8.63a8.31,8.31,0,0,0-5.59,2.15,2.43,2.43,0,0,0-1-.22A2.36,2.36,0,0,0,79,12.89a2.32,2.32,0,0,0,1,1.86,7.7,7.7,0,0,0-.26,2V27.13h.51V16.75A7.52,7.52,0,0,1,80.42,15c0-.17.08-.33.13-.49a1.9,1.9,0,0,1-.44-.3,1.83,1.83,0,0,1,1.27-3.17,2,2,0,0,1,.6.1,1.89,1.89,0,0,1,.47.24l.38-.35A7.82,7.82,0,0,1,88,9.13a7.71,7.71,0,0,1,5.57,2.38l.35-.37A8.25,8.25,0,0,0,88,8.63Z"
          />
          <path
            class="cls-178"
            d="M21.69,8.63a8.33,8.33,0,0,0-6.35,2.92c.12.13.22.27.33.41a7.8,7.8,0,0,1,6-2.83,7.7,7.7,0,0,1,7.75,7.61v10.4H30V16.74A8.19,8.19,0,0,0,21.69,8.63Z"
          />
          <path
            class="cls-178"
            d="M9,9.69a7.1,7.1,0,0,0-7.15,7V27.14h.51V16.72A6.59,6.59,0,0,1,9,10.19a6.6,6.6,0,0,1,6.65,6.53V27.14h.51V16.72A7.11,7.11,0,0,0,9,9.69Z"
          />
          <path
            class="cls-178"
            d="M74.26,8.62V18a8.91,8.91,0,0,1-17.82-.09,8.85,8.85,0,0,1,8.91-8.75,9,9,0,0,1,5.6,2v.76a8.33,8.33,0,0,0-5.6-2.13,8.17,8.17,0,1,0,8.32,8.16V8.62h-.51v9.26a7.81,7.81,0,1,1-7.81-7.66A7.83,7.83,0,0,1,71,12.55v.87a7.24,7.24,0,0,0-5.6-2.62,7.09,7.09,0,1,0,7.22,7.08V8.62h-.52s0,9.24,0,9.26a6.71,6.71,0,1,1-6.71-6.58,6.73,6.73,0,0,1,5.6,3v1.21a6.09,6.09,0,1,0-5.6,8.41,6.08,6.08,0,0,0,6.12-6s0-9.26,0-9.26H71v1.83a9.47,9.47,0,0,0-5.6-1.82,9.35,9.35,0,0,0-9.42,9.25,9.35,9.35,0,0,0,9.42,9.26,9.52,9.52,0,0,0,5.59-1.81A9.28,9.28,0,0,0,72.37,24c-.11.12-.21.24-.33.36v2.75h.51v-3.3l0,.06a9.38,9.38,0,0,0,1.15-1.65,9.24,9.24,0,0,0,.61-1.36v6.25h.51V8.62ZM71,17.83v.05a5.47,5.47,0,1,1,0-.06Z"
          />
          <path class="cls-178" d="M37.58,27.14h.51V25.33l-.51-.4Z" />
          <path
            class="cls-178"
            d="M81.91,16.73v10.4h.51V16.74a5.56,5.56,0,0,1,9.64-3.64l.35-.38A6.12,6.12,0,0,0,88,10.81,6,6,0,0,0,81.91,16.73Z"
          />
          <path
            class="cls-178"
            d="M21.69,10.8a6.09,6.09,0,0,0-5.1,2.75v0A8.31,8.31,0,0,0,3.38,10.8a2.44,2.44,0,0,0-1-.22A2.32,2.32,0,0,0,1,14.79a7.84,7.84,0,0,0-.25,1.95v10.4h.51V16.74c0-.14,0-.28,0-.42a8.62,8.62,0,0,1,.11-.87c0-.14,0-.27.08-.41h0c0-.16.08-.32.13-.48h0a2.12,2.12,0,0,1-.43-.28v0a1.8,1.8,0,0,1-.62-1.35,1.85,1.85,0,0,1,1.86-1.83,2,2,0,0,1,.61.1H3a1.91,1.91,0,0,1,.45.23l.38-.35A7.77,7.77,0,0,1,9,9.13a7.68,7.68,0,0,1,7.75,7.61V27.13h.52V16.74a8.09,8.09,0,0,0-.16-1.56,8.76,8.76,0,0,1,.16,1.55h0a4.43,4.43,0,0,1,8.86,0V27.14h.51V16.73a4.89,4.89,0,0,0-4.94-4.84A4.94,4.94,0,0,0,17.07,15a.07.07,0,0,0,0,.05,8.23,8.23,0,0,0-.47-1.48,5.37,5.37,0,0,1,.21.56,5.58,5.58,0,0,1,4.87-2.85,5.5,5.5,0,0,1,5.54,5.43V27.14h.51V16.73A6,6,0,0,0,21.69,10.8ZM1,14.83,1,14.8Z"
          />
          <path
            class="cls-178"
            d="M9,11.89a4.91,4.91,0,0,0-4.95,4.84V27.14h.51V16.73a4.44,4.44,0,0,1,8.87,0V27.14h.51V16.73A4.9,4.9,0,0,0,9,11.89Z"
          />
        </g>
      </g>
    </svg> -->
  </div>
</template>


<script>
export default {
  name: "mamnoonstreet",
  data() {
    return {
      link: "https://www.trycaviar.com/m/mamnoon-street-6597"
    };
  },
  props: ["linkOut","comingsoon"],
  methods: {
    openLink(e) {
      window.open(e, "_blank");
      console.log(e);
    },
    openSevenRooms(e){
      document.getElementById(e).click();

      console.log('console log mbar')
      console.log(e)
    }






  }
};
</script>

        <style lang="scss">
.cls-178 {
  fill: #49494a;
}

.halfwidth-yellow1.wider.mbar.mbar12{
  width: 33.33%;

  svg{
    transform: translate(-50%,-72%) !important;
  }
}



@media only screen and (max-width: 768px) {
  .halfwidth-yellow1.wider.mbar.mbar12{
  width: 100%;
}

}

.cls-1mbargrey{
  fill:#49494a;
  fill: #fbf152;
}

.coming-soon2{
  color: #f05d5b;
    bottom: 14%;
  left: 50%;
  position: absolute;
  transform: translate(-50%,-50%);
  font-weight: 100;

}


</style>